<template>
  <div class="register absolute" style="background:#fff;">
    <van-nav-bar
      :title="$t('m.dl_span21')"
      @click-left="onClickLeft"
      left-arrow
    ></van-nav-bar>
    <!-- <div class="shading" style="padding:0 40px;">
      <div
        class="pictrue acea-row row-center-wrapper"
        style="height: 0.8rem;"
      ></div>
        <div class="biaoti">
        <div style="display:flex;align-items:center;">
          <img src="../../assets/images/new/qian.png" style="width: 45px;height: 45px;border-radius:0;" alt="">
        </div>
        {{$t('m.dl_span07')}}
        <div style="font-size:13px;color:#999;margin-top:6px;">
        {{$t('m.dl_span08')}}
        </div>
      </div>
    </div> -->
    <div class="register_block">
      <div class="register_block_list">
        <!-- <img
          src="../../assets/images/user2.png"
          style="width: 16px;height: 16px;margin-right:18px"
          alt=""
        /> -->
        <input v-model="password" :placeholder="$t('m.dl_span19')" />
      </div>
      <div class="register_block_list">
        <!-- <img
          src="../../assets/images/user2.png"
          style="width: 16px;height: 16px;margin-right:18px"
          alt=""
        /> -->
        <input v-model="password1" :placeholder="$t('m.dl_span20')" />
      </div>
      <div class="register_block_list">
        <!-- <img
          src="../../assets/images/user2.png"
          style="width: 16px;height: 16px;margin-right:18px"
          alt=""
        /> -->
        <input v-model="password2" :placeholder="$t('m.dl_span18')" />
      </div>
      <van-button class="register_submit" @click="registerReset">{{
        $t("m.tijiao")
      }}</van-button>
    </div>

    <div
      v-if="show"
      style="background: rgba(0, 0, 0, 0.5);position: fixed;width: 100%;height: 100%;left:0;top:0;display: flex;align-items: center;justify-content: center;"
    >
      <div
        style="background: rgba(0, 0, 0, 0.7);width:130px;height:130px;border-radius:8px;text-align:center;line-height:130px;color:#fff;font-size:16px;"
      >
        {{ $t("m.tijiaoing") }}
      </div>
    </div>
  </div>
</template>

<script>
import request from "@utils/request";
import { loginPass } from "@api/user";

export default {
  name: "RetrievePassword",
  data: function() {
    return {
      show: false,
      password: "",
      password1: "",
      password2: ""
    };
  },
  mounted: function() {
    request.get("/shop/sign/status", {}, { login: true });
  },
  methods: {
    onClickLeft() {
      this.$router.go(-1);
    },
    registerReset() {
      var that = this;
      // const { password, password1, password2 } = that;
      // console.log(password2);
      // try {
      //   await that
      //     .$validator({
      //       password: [required(required.message("密码"))],
      //       password1: [required(required.message("新密码"))],
      //       password2: [required(required.message("确认新密码"))]
      //     })
      //     .validate({ password, password1, password2 });
      // } catch (e) {
      //   return validatorDefaultCatch(e);
      // }
      // if (password1 != password2) {
      //   this.$dialog.error("两次密码不一致！");
      //   return;
      // }
      this.show = true;
      loginPass({
        old: that.password,
        new: that.password1,
        new2: that.password2
      })
        .then(res => {
          this.show = false;
          that.$dialog.success("密码修改成功").then(() => {
            that.$router.push({ name: "Login" });
          });
        })
        .catch(res => {
          this.show = false;
          console.log(res.response);
          this.$dialog.error(res.response.data.msg);
        });
    }
  }
};
</script>
<style scoped lang="less">
.biaoti {
  // text-align: center;
  font-size: 25px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #333;
}

.register_submit {
  width: 100%;
  margin: 0 auto;
  height: 45px;
  background: var(--bg-color);
  border-radius: 30px;
  margin-top: 40px;
  text-align: center;
  line-height: 40px;
  color: #ffffff;
  border: 0px solid;
  font-size: 15px;
  font-weight: bold;
}

.register_block {
  padding: 0 40px;
  margin-top: 20px;
}
.register_block_list {
  width: 100%;
  height: 50px;
  padding: 0 0px;
  /* background: #f1f1f3; */
  /* border-radius: 5px; */
  display: flex;
  align-items: center;
  font-size: 14px;

  border-bottom: 1px solid #eee;
}
.register_block_list input {
  line-height: 50px;
  height: 50px;
  width: 100%;
  font-size: 15px;
}

.register_code_lists {
  border: 1px solid #ff1900;
  text-align: center;
  color: #ff1900;
  border-radius: 6px;
  width: 36%;
  height: 45px;
  margin-left: 15px;
  line-height: 45px;
}
.register_code_list {
  width: 100%;
  height: 50px;
  padding: 0 15px;
  background: #f1f1f3;
  border-radius: 5px;
  display: flex;
  align-items: center;
  font-size: 14px;
}
.register_code {
  display: flex;
  align-items: center;
  margin-top: 15px;
}
.register_tit {
  display: flex;
  align-items: center;
  position: relative;
  justify-content: center;
  padding: 5px;
}
.register_tit img {
  width: 30px;
  height: 30px;
  position: absolute;
  left: 15px;
}
.register_tit p {
  text-align: center;
  text-align: center;
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #343434;
  line-height: 35px;
}
/* 清除浮动*/
.am-fl {
  float: left;
}
.am-fr {
  float: right;
}
.am-cf:after {
  content: "";
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
}
.am-cf {
  zoom: 1;
}
/deep/ .van-nav-bar .van-icon {
  color: #333;
}
</style>
